import React from 'react';

import { IPersonaFront } from '@api/routers/user/service';
import styled from '@emotion/styled';

import { useDepositsOrThrow } from '@web/features/staking/hooks';
import { BulkAction } from '@web/ui/components/BulkAction';

import { StakingGridItem } from './StakingGridItem';

const StakingGridContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing('3000')};
  padding-bottom: 80px;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    gap: 80px;
  }
`;

const Grid = styled.div`
  width: 100%;
  display: grid;
  justify-items: center;
  align-items: center;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing('1000')};

  ${({ theme }) => theme.breakpoints.up('md')} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const StyledBulkAction = styled(BulkAction)`
  position: fixed;
  bottom: ${({ theme }) => theme.spacing('1000')};
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  width: 90%;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: auto;
  }
`;

export interface IStakingGridProps {
  items: IPersonaFront[];
  selectedItems: IPersonaFront[];
  lockedItems: IPersonaFront[];
  bulkActions: React.ReactNode[];
  onSelectAll(): void;
  onClearAll(): void;
  onItemClick(item: IPersonaFront): void;
}

export const StakingGrid = ({
  items,
  bulkActions,
  selectedItems,
  lockedItems,
  onItemClick,
  onSelectAll,
  onClearAll,
}: IStakingGridProps) => {
  const { depositsRecord } = useDepositsOrThrow();

  return (
    <StakingGridContainer>
      <Grid id="grid-of-personas">
        {items.map((persona) => {
          const deposit = depositsRecord[persona.tokenId.toString()] ?? null;

          return (
            <StakingGridItem
              key={persona.tokenId}
              persona={persona}
              deposit={deposit}
              selected={
                !!selectedItems.find((i) => i.tokenId === persona.tokenId)
              }
              locked={!!lockedItems.find((i) => i.tokenId === persona.tokenId)}
              onClick={() => onItemClick(persona)}
            />
          );
        })}
      </Grid>

      {selectedItems.length > 0 && (
        <StyledBulkAction
          selected={selectedItems.length}
          actions={bulkActions}
          onSelectAll={onSelectAll}
          onClearAll={onClearAll}
        />
      )}
    </StakingGridContainer>
  );
};
